import { EquipamentoDropDown } from "../../models/equipamento_dropdown";
import { IGetEquipamentosDropDownUseCase } from "../../../presentation/useCases/read/get_equipamentos_dropdown_use_case";
import { IRhRepository } from "../../repositories/rh_repository";

/**
 * GetEquipamentosDropDownUseCase
 */

export class GetEquipamentosDropDownUseCase implements IGetEquipamentosDropDownUseCase {
  constructor(
    private readonly repository: IRhRepository,
  ) { }

  async getEquipamentosDropDown(): Promise<EquipamentoDropDown[]> {
    const response = await this.repository.getEquipamentosDropDown();
    return response;
  }
}